import { render } from "./PracticeTestAIView.vue?vue&type=template&id=420da710&scoped=true"
import script from "./PracticeTestAIView.vue?vue&type=script&lang=js"
export * from "./PracticeTestAIView.vue?vue&type=script&lang=js"

import "./PracticeTestAIView.vue?vue&type=style&index=0&id=420da710&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420da710"]])

export default __exports__